import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar } from "recharts";

const MultiLineChart = ({ Data, xaxisName, lineDataKey1, lineDataKey2 }) => {
    return (
        <ResponsiveContainer width="100%" height={400}>
            <BarChart data={Data} margin={{ top: 20, right: 30, left: 20, bottom: 80 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                    dataKey={xaxisName}
                />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey={lineDataKey1} fill="#8884d8" />
                <Bar dataKey={lineDataKey2} fill="#82ca9d" />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default MultiLineChart;
